<template>
	<j-base-input-long-text
		:value="value"
		:rows="10"
		@input="$emit('input', $event)"
	/>
</template>

<script>
/**
 * This component is responsible for parsing json logic for commissions and displaying UI elements
 * When you update UI it returns new json logic string
 */

/*
Some examples of json logic rules for commissions


- Percentage from premium:
`{ "*": [ {"var" : "totalPremium"}, 0.15 ]}`

- Flat fee:
`[100, "HKD"]`


*/
import JBaseInputLongText from "@/components/JBaseInputLongText"

export default {
	components: { JBaseInputLongText },
	props: {
		value: {
			validator(val) {
				return val === null || typeof val === "string"
			}
		}
	},

	data: () => ({
		jsonRule: null
	}),

	methods: {}
}
</script>
